export const triggerGlobalError = (statusCode) => {
  const event = new CustomEvent("api-error", { detail: statusCode });
  window.dispatchEvent(event);
};
